var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 491.969 491.969",
    style: {
      enableBackground: "new 0 0 491.969 491.969"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "412.654,51.687 332.039,51.687 332.039,86.06 412.654,151.644   "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.654,307.131 412.654,273.045 332.039,207.352 245.984,137.227 79.312,273.045 79.312,458.4 184.386,458.4     184.386,275.879 307.582,275.879 307.582,458.4 412.654,458.4   "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.312,255.517 245.984,119.698 332.039,189.823 412.654,255.517 449.625,285.643 491.969,233.679     412.654,169.157 332.039,103.573 245.984,33.568 0,233.679 42.343,285.643   "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeButton);
export default __webpack_public_path__ + "static/media/HomeButton.0e9317385653fdff25187c92e3e4f512.svg";
export { ForwardRef as ReactComponent };